import { apiCall } from '@/lib/api';
import { createMutation, createQuery, useQueryClient } from '@tanstack/solid-query';
import type { CreateRoleBody, UpdateRoleBody } from '@uchat-team-management/shared';
import { createRole, deleteRole, listRoles, updateRole } from './api';

export const rolesKey = () => ['roles'] as const;

export const useRoles = () =>
  createQuery(() => ({
    queryKey: rolesKey(),
    queryFn: () => apiCall(listRoles, {}),
    staleTime: 60_000,
  }));

export const useCreateRole = () => {
  const qc = useQueryClient();
  return createMutation(() => ({
    mutationFn: (body: CreateRoleBody) => apiCall(createRole, { body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['roles'] }),
  }));
};

export const useUpdateRole = () => {
  const qc = useQueryClient();
  return createMutation(() => ({
    mutationFn: (vars: { roleId: string; body: UpdateRoleBody }) =>
      apiCall(updateRole, { params: { roleId: vars.roleId }, body: vars.body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['roles'] }),
  }));
};

export const useDeleteRole = () => {
  const qc = useQueryClient();
  return createMutation(() => ({
    mutationFn: (roleId: string) => apiCall(deleteRole, { params: { roleId } }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['roles'] }),
  }));
};
